module.exports = __webpack_public_path__ + "img/dndx.f09af6f2.png";